<template>
    <v-row>
        <v-col>
            <v-sheet height="400" width="200%" color="greeen lighten-2">

            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex';

  export default {
    components: { },
    name: "Calendar2",
    data() {
      return {
          activeeventtime:undefined,
          eventdialog:false,
          calendars:[],
          times:[
              {text:"12:00 AM",value:"00:00:00.000Z"},
              {text:"12:30 AM",value:"00:00:30.000Z"},
              {text:"1:00 AM",value:"01:00:00.000Z"},
              {text:"1:30 AM",value:"01:00:30.000Z"},
              {text:"2:00 AM",value:"02:00:00.000Z"},
              {text:"2:30 AM",value:"02:00:30.000Z"},
              {text:"3:00 AM",value:"03:00:00.000Z"},
              {text:"3:30 AM",value:"03:00:30.000Z"},
              {text:"4:00 AM",value:"04:00:00.000Z"},
              {text:"4:30 AM",value:"04:00:30.000Z"},
              {text:"5:00 AM",value:"05:00:00.000Z"},
              {text:"5:30 AM",value:"05:00:30.000Z"},
              {text:"6:00 AM",value:"06:00:00.000Z"},
              {text:"6:30 AM",value:"06:00:30.000Z"},
              {text:"7:00 AM",value:"07:00:00.000Z"},
              {text:"7:30 AM",value:"07:00:30.000Z"},
              {text:"8:00 AM",value:"08:00:00.000Z"},
              {text:"8:30 AM",value:"08:00:30.000Z"},
              {text:"9:00 AM",value:"09:00:00.000Z"},
              {text:"9:30 AM",value:"09:00:30.000Z"},
              {text:"10:00 AM",value:"10:00:00.000Z"},
              {text:"10:30 AM",value:"10:00:30.000Z"},
              {text:"11:00 AM",value:"11:00:00.000Z"},
              {text:"11:30 AM",value:"11:00:30.000Z"},
              {text:"12:00 PM",value:"12:00:00.000Z"},
              {text:"12:30 PM",value:"12:00:30.000Z"},
              {text:"1:00 PM",value:"13:00:00.000Z"},
              {text:"1:30 PM",value:"13:00:30.000Z"},
              {text:"2:00 PM",value:"14:00:00.000Z"},
              {text:"2:30 PM",value:"14:00:30.000Z"},
              {text:"3:00 PM",value:"15:00:00.000Z"},
              {text:"3:30 PM",value:"15:00:30.000Z"},
              {text:"4:00 PM",value:"16:00:00.000Z"},
              {text:"4:30 PM",value:"16:00:30.000Z"},
              {text:"5:00 PM",value:"17:00:00.000Z"},
              {text:"5:30 PM",value:"17:00:30.000Z"},
              {text:"6:00 PM",value:"18:00:00.000Z"},
              {text:"6:30 PM",value:"18:00:30.000Z"},
              {text:"7:00 PM",value:"19:00:00.000Z"},
              {text:"7:30 PM",value:"19:00:30.000Z"},
              {text:"8:00 PM",value:"20:00:00.000Z"},
              {text:"8:30 PM",value:"20:00:30.000Z"},
              {text:"9:00 PM",value:"21:00:00.000Z"},
              {text:"9:30 PM",value:"21:00:30.000Z"},
              {text:"10:00 PM",value:"22:00:00.000Z"},
              {text:"10:30 PM",value:"22:00:30.000Z"},
              {text:"11:00 PM",value:"23:00:00.000Z"},
              {text:"11:30 PM",value:"23:00:30.000Z"}
          ],
          value:'2020-06-08',
          type:'week'
      }
    },
    computed:{
      ...mapState(['org', 'icons', 'events','activeevent']),
    },
    watch:{

    },
    mounted() {
        this.getCalendars()
    },
    methods: {
      ...mapActions(['get','post','openGet','getEvent']),
        event(e){
          console.log(e)
        },
        async getCalendars(){
          console.log('Getting')
            let data = await this.openGet({path:'api/caltimes/timesbyfestival/bfgtrd-4egrtfh-577388d-0sdrhf'})
            this.eventtimes = data
        }
    },
  }
</script>

